"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.hasFullPack = hasFullPack;
exports.loadPacksPage = loadPacksPage;
exports.loadFullPack = loadFullPack;
exports.buyPack = buyPack;

var _auth = require("./auth");

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _utils = require("utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PAGE_LOAD = "ms/packs/page_load";
var PAGE_LOAD_SUCCESS = "ms/packs/page_load_success";
var PAGE_LOAD_FAIL = "ms/packs/page_load_fail";

var LOAD = "ms/packs/load";
var LOAD_SUCCESS = "ms/packs/load_success";
var LOAD_FAIL = "ms/packs/load_fail";

var BUY = "ms/packs/buy";
var BUY_SUCCESS = "ms/packs/buy_success";
var BUY_FAIL = "ms/packs/buy_fail";

var loadingPromise = void 0;

var initialState = {
  fullPacks: {},
  packs: [],
  pages: [],
  fullLoading: false,
  fullLoadingError: null
};

// transitory helper vars
var fullPacks = void 0;

// Reducer

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        fullLoading: true,
        fullLoadingError: null
      });

    case LOAD_SUCCESS:
      fullPacks = (0, _extends3.default)({}, state.fullPacks);
      fullPacks[action.result.pack.id] = action.result.pack;

      return (0, _extends3.default)({}, state, {
        fullLoading: false,
        fullLoadingError: null,
        fullPacks: fullPacks
      });

    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        fullLoading: false,
        fullLoadingError: action.error
      });

    case PAGE_LOAD:
      return (0, _extends3.default)({}, state, {
        loadingPage: true,
        loadingPageError: null
      });

    case PAGE_LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        packs: action.result.packs,
        pages: action.result.pages,
        loadingPage: false,
        loadingPageError: null
      });

    case PAGE_LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingPage: false,
        loadingPageError: action.error
      });

    case _auth.LOGIN_SUCCESS:
    case _auth.LOGOUT_SUCCESS:
      return state;

    case BUY_SUCCESS:
      fullPacks = (0, _extends3.default)({}, state.fullPacks);
      fullPacks[action.result.pack.id].acl = action.result.acl;

      return (0, _extends3.default)({}, state, {

        fullPacks: fullPacks
      });

    default:
      return state;
  }
}

// Helper functions

function hasFullPack(globalState, id) {
  return !!globalState.assets.fullAssets[id];
}

// Action creators

function loadPacksPage() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$page = _ref.page,
      page = _ref$page === undefined ? 1 : _ref$page,
      _ref$limit = _ref.limit,
      limit = _ref$limit === undefined ? 50 : _ref$limit,
      collectionType = _ref.collectionType;

  return function (dispatch, getState) {
    if (getState().packs.packs && getState().packs.packs.length) return;

    var queryString = collectionType ? "type=" + collectionType + "&page=" + page + "&limit=" + limit : "page=" + page + "&limit=" + limit;

    return dispatch({
      types: [PAGE_LOAD, PAGE_LOAD_SUCCESS, PAGE_LOAD_FAIL],
      promise: function promise(client) {
        return client.get("v1/packs?" + queryString);
      }
    });
  };
}

function loadFullPack(id) {
  return function (dispatch, getState) {
    if (getState().packs.fullPacks[id]) return;

    return dispatch({
      types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
      promise: function promise(client) {
        return client.get("v1/packs/" + id).then(function (result) {
          return { pack: result };
        });
      }
    });
  };
}

function buyPack(_ref2) {
  var packId = _ref2.packId,
      priceMapId = _ref2.priceMapId;

  return function (_ref3) {
    var amount = _ref3.amount,
        paymentMethodToken = _ref3.paymentMethodToken,
        name = _ref3.name,
        company = _ref3.company,
        address1 = _ref3.address1,
        address2 = _ref3.address2,
        postalCode = _ref3.postalCode,
        country = _ref3.country,
        countryCode = _ref3.countryCode,
        vatNo = _ref3.vatNo,
        vatSignature = _ref3.vatSignature,
        paymentMethodNonce = _ref3.paymentMethodNonce,
        deviceData = _ref3.deviceData;

    return function (dispatch, getState) {
      return dispatch({
        types: [BUY, BUY_SUCCESS, BUY_FAIL],
        promise: function promise(client) {
          return client.post("v1/payments/packs", {
            data: {
              packID: packId,
              amount: amount,
              priceMapId: priceMapId,
              paymentMethod: paymentMethodToken ? {
                paymentMethodToken: paymentMethodToken
              } : {
                name: name,
                company: company,
                address1: address1,
                address2: address2,
                postalCode: postalCode,
                country: country,
                countryCode: countryCode,
                vatNo: vatNo,
                vatSignature: vatSignature,
                paymentMethodNonce: paymentMethodNonce,
                deviceData: deviceData
              }
            }
          }).then(function (result) {
            if (process.env.NODE_ENV === "production") {
              var pack = getState().packs.fullPacks[packId];
              var priceMap = pack.priceMap.find(function (map) {
                return map.id == priceMapId;
              });

              var id = (0, _utils.UUIDv4)();
            }

            return result;
          }).then(function (result) {
            return { pack: result.pack, acl: result.acl };
          });
        }
      });
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/packs.js
// module id = 1122
// module chunks = 0